import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
} from 'recharts';
import { CustomTooltip } from './custom-tooltip';
import { ClimaDia } from '../../service/clima';

type Props = {
  weather: ClimaDia | null;
  globalMaxRain: number;
};

const RainChart = ({ weather, globalMaxRain }: Props) => {
  const chartData =
    weather?.por_hora?.map((h) => ({
      hour: h.hora,
      rain: h.precipitacao ?? 0,
    })) ?? [];

  const hours = chartData.map((d) => d.hour);

  const axis = {
    tickLine: false,
    axisLine: false,
    tick: { fontSize: 15, fill: '#333', fontWeight: '500' } as const,
    tickMargin: 7,
  };

  const maxYBase = globalMaxRain;
  const maxY = Math.ceil((maxYBase + 2) / 5) * 5;

  return (
    <div>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={chartData} margin={{ right: 8, left: 10, top: 10 }}>
          <CartesianGrid strokeDasharray="5 5" />
          <XAxis dataKey="hour" ticks={hours} {...axis} />
          <YAxis
            orientation="right"
            domain={[0, maxY]}
            tickFormatter={(value) => `${value} mm`}
            {...axis}
          />
          <CustomTooltip formatter={(value) => [`${value} mm`, 'Chuva']} />
          <Bar dataKey="rain" fill="#1f5a92" radius={[2, 2, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default RainChart;
